import { ResponsiveContainer } from 'recharts';

// Start with valid dimensions while ResizeObserver measures a newly opened tab.
// The measured parent size immediately replaces these initial dimensions.
export const ChartViewport = ({ children, ...props }) => (
  <ResponsiveContainer initialDimension={{width: 320, height: 175}} minWidth={0} {...props}>
    {children}
  </ResponsiveContainer>
);